import { TextField } from '@components/common';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { regEmail, InputStatus } from '@constants/claim';
import { onChangeEmail } from '@components/login-panel/hooks';
import classes from './EmailForm.module.css';

export const EmailForm = ({ title, onChange }) => {
  const { email: defaultEmail } = useSelector((state) => state.policy);
  const validEmail = regEmail.test(defaultEmail) ? defaultEmail : undefined;
  const [email, setEmail] = useState(validEmail);
  const [emailStatus, setEmailStatus] = useState(
    validEmail ? InputStatus.Changed : InputStatus.Init,
  );
  const isEmailValid = regEmail.test(email);
  const isEmailShownValid = emailStatus === InputStatus.Init || isEmailValid;
  const emailHelperText = email ? 'Invalid email address' : 'Email is required';
  return (
    <div className={classes.email_module}>
      <header className={classes.header}>{title}</header>
      <TextField
        id="login-email-input"
        label="Email"
        placeholder="Email"
        variant="outlined"
        color="input"
        error={!isEmailShownValid}
        defaultValue={email}
        helperText={isEmailShownValid ? ' ' : emailHelperText}
        onChange={(event) => {
          onChangeEmail({
            event,
            setEmail,
            emailStatus,
            setEmailStatus,
          });
          onChange(event, isEmailValid);
        }}
      />
    </div>
  );
};
